module.exports = __webpack_public_path__ + "img/phone.bf7c30d.svg";